import {Fraction} from '../../../Domain/Fraction';

export function formatLinearProgression(fraction: Fraction | null): {
    formatted: string;
    unit: string;
    sign: string;
} {
    if (fraction === null) {
        return {
            formatted: '-',
            unit: '',
            sign: '',
        };
    }

    let sign = '-';
    if (fraction.percentage > 100) {
        sign = '↗';
    }
    if (fraction.percentage < 100) {
        sign = '↘';
    }

    return {
        formatted: fraction.percentage.toFixed(1),
        unit: '%',
        sign: sign,
    };
}
